import { render, staticRenderFns } from "./index.vue?vue&type=template&id=50a3fcfd&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AppBreadCrumb: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/common/AppBreadCrumb.vue').default})
